import FieldProto from "../../proto/field-proto";
import Condition from "../../../model2/conditions/condition";
import {ConditionType} from "../../../model2/conditions/condition-types";

export enum FieldConditionRenderMode {
    CONDITION               = 1, // generic - used in dashboards, custom views etc
    FILTER_ITEMS_COLLECTION = 2,
    FILTER_COLLECTION       = 3,
}

export type FieldConditionFormProps = {
    field               : FieldProto
    condition           : Condition
    onChangeCallback    : {(type:ConditionType, value: any): void}
    renderMode          : FieldConditionRenderMode
}